<div class="main">
  <div class="main__container">
    @if (!showProject) {
    <agenda-customer-ui-maintenance-page />
    } @else {
    <main-container-history />
    }
  </div>
</div>
